import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useSnackbar } from "notistack";

const AddProduct = () => {
  const [formData, setFormData] = useState({
    gender: "",
    category: "",
    name: "",
    description: "",
    grossWeight: 0,
    goldKt: 0,
    goldColor: "",
    diamondWeight: 0,
    diamondColorAndClarity: "",
    height: 0,
    width: 0,
    length: 0,
    productId: "",
    image1: null,
    image2: null,
    image3: null,
    video: null,
  });

  const [imagePreviews, setImagePreviews] = useState([]);
  const [videoPreview, setVideoPreview] = useState();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();

  const URL = process.env.REACT_APP_URL;

  const getCategoryOptions = () => {
    switch (formData.gender) {
      case "Man":
        return ["Bracelet", "Ring"];
      case "Woman":
        return [
          "Necklace",
          "Bracelet",
          "Earrings",
          "Pendantset",
          "Ring",
          "Mangalsutra",
          "Bengal",
          "Coupleband"
        ];
      default:
        return [];
    }
  };

  const handleRemoveFile = (key) => {
    setFormData((prevState) => ({
      ...prevState,
      [key]: null,
    }));

    if (key.startsWith("image")) {
      setImagePreviews((prev) => {
        const index = key === "image1" ? 0 : key === "image2" ? 1 : 2;
        const newPreviews = [...prev];
        newPreviews[index] = null;
        return newPreviews;
      });
    }

    if (key === "video") {
      setVideoPreview(null);
    }
  };

  const handleInputChange = (e) => {
    const { name, value, files } = e.target;

    if (files && files.length > 0) {
      const file = files[0];

      if (name.startsWith("image")) {
        if (!file.type.startsWith("image/")) {
          enqueueSnackbar("Please upload a valid image file.", {
            variant: "error",
          });
          return;
        }
        if (file.size > 5 * 1024 * 1024) {
          enqueueSnackbar("File size must be less than 5MB.", {
            variant: "error",
          });
          return;
        }

        setFormData({ ...formData, [name]: file });

        const reader = new FileReader();
        reader.onloadend = () => {
          setImagePreviews((prev) => {
            const newPreviews = [...prev];
            newPreviews[name === "image1" ? 0 : name === "image2" ? 1 : 2] =
              reader.result;
            return newPreviews;
          });
        };
        reader.readAsDataURL(file);
      } else if (name === "video") {
        if (!file.type.startsWith("video/")) {
          enqueueSnackbar("Please upload a valid video file.", {
            variant: "error",
          });
          return;
        }
        if (file.size > 30 * 1024 * 1024) {
          enqueueSnackbar("Video size must be less than 10MB.", {
            variant: "error",
          });
          return;
        }

        setFormData({ ...formData, video: file });
        setVideoPreview(window.URL.createObjectURL(file)); // Video preview
      }
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.image1) {
      enqueueSnackbar("Image 1 is required.", { variant: "error" });
      return;
    }
    setIsSubmitting(true);
    const data = new FormData();

    Object.keys(formData).forEach((key) => {
      if (
        formData[key] &&
        key !== "image1" &&
        key !== "image2" &&
        key !== "image3" &&
        key !== "video"
      ) {
        data.append(key, formData[key]);
      }
    });

    data.append("image1", formData.image1);
    if (formData.image2) data.append("image2", formData.image2);
    if (formData.image3) data.append("image3", formData.image3);
    if (formData.video) data.append("video", formData.video); // Append video file

    try {
      const response = await axios.post(`${URL}products`, data, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (response.status === 201) {
        enqueueSnackbar("Product added successfully!", { variant: "success" });
        navigate("/products");
      } else {
        setIsSubmitting(false);

        enqueueSnackbar(response.statusText || "Failed to add product.", {
          variant: "error",
        });
      }
    } catch (error) {
      setIsSubmitting(false);

      const errorMessage =
        error.response?.data.error || "Something went wrong.";
      enqueueSnackbar(errorMessage, { variant: "error" });
    }
  };

  return (
    <div className="max-w-4xl mx-auto p-6 bg-white shadow-lg rounded-lg">
      <h2 className="text-2xl font-semibold mb-6 text-gray-700">
        Add Diamond Jewelry
      </h2>
      <form onSubmit={handleSubmit} className="space-y-6">
        <div>
          <label
            htmlFor="gender"
            className="block text-sm font-medium text-gray-700"
          >
            Gender
          </label>
          <select
            id="gender"
            name="gender"
            className="mt-1 block w-full p-2 border border-gray-300 rounded-lg focus:ring-indigo-500 focus:border-indigo-500"
            value={formData.gender}
            onChange={handleInputChange}
            required
          >
            <option value="">Select Gender</option>
            <option value="Man">Man</option>
            <option value="Woman">Woman</option>
          </select>
        </div>

        {formData.gender && (
          <div>
            <label
              htmlFor="category"
              className="block text-sm font-medium text-gray-700"
            >
              Category
            </label>
            <select
              id="category"
              name="category"
              className="mt-1 block w-full p-2 border border-gray-300 rounded-lg focus:ring-indigo-500 focus:border-indigo-500"
              value={formData.category}
              onChange={handleInputChange}
              required
            >
              <option value="">Select Category</option>
              {getCategoryOptions().map((category) => (
                <option key={category} value={category}>
                  {category == "Bengal" ? "Bangel" :category }
                  </option>
              ))}
            </select>
          </div>
        )}

        <div>
          <label
            htmlFor="name"
            className="block text-sm font-medium text-gray-700"
          >
            Name
          </label>
          <input
            type="text"
            id="name"
            name="name"
            className="mt-1 block w-full p-2 border border-gray-300 rounded-lg focus:ring-indigo-500 focus:border-indigo-500"
            value={formData.name}
            onChange={handleInputChange}
            required
          />
        </div>

        <div>
          <label
            htmlFor="description"
            className="block text-sm font-medium text-gray-700"
          >
            Description
          </label>
          <textarea
            id="description"
            name="description"
            style={{ height: "20vh" }}
            className="mt-1 block w-full p-3 border border-gray-300 rounded-lg focus:ring-indigo-500 focus:border-indigo-500"
            value={formData.description}
            onChange={handleInputChange}
            required
          />
        </div>

        {[
          { name: "grossWeight", label: "Gross Weight" },
          { name: "goldKt", label: "Gold KT" },
          { name: "goldColor", label: "Gold Color" },
          { name: "diamondWeight", label: "Diamond Weight" },
          {
            name: "diamondColorAndClarity",
            label: "Diamond Color and Clarity",
          },
          { name: "height", label: "Height" },
          { name: "width", label: "Width" },
          { name: "length", label: "Length" },
          { name: "productId", label: "Product ID" },
        ].map((field) => (
          <div key={field.name}>
            <label
              htmlFor={field.name}
              className="block text-sm font-medium text-gray-700"
            >
              {field.label}
            </label>
            <input
              type="text"
              id={field.name}
              name={field.name}
              className="mt-1 block w-full p-2 border border-gray-300 rounded-lg focus:ring-indigo-500 focus:border-indigo-500"
              value={formData[field.name]}
              onChange={handleInputChange}
              required
            />
          </div>
        ))}

        {["image1", "image2", "image3"].map((imageField, index) => (
          <div key={imageField}>
            <label
              htmlFor={imageField}
              className="block text-sm font-medium text-gray-700"
            >
              {`Image ${index + 1}`}
            </label>
            {!formData[imageField] ? (
              <input
                type="file"
                id={imageField}
                name={imageField}
                className="mt-1 block w-full p-2 border border-gray-300 rounded-lg focus:ring-indigo-500 focus:border-indigo-500"
                accept="image/*"
                onChange={handleInputChange}
              />
            ) : (
              <div>
                <button
                  type="button"
                  onClick={() => handleRemoveFile(imageField)}
                  className="text-red-500"
                >
                  Remove {imageField}
                </button>
                <div className="mt-2">
                  <img
                    src={imagePreviews[index]}
                    alt="Preview"
                    className="w-32 h-auto border border-gray-200"
                  />
                </div>
              </div>
            )}
            {/* {imagePreviews[index] && (
              <div className="mt-3">
                <img
                  src={imagePreviews[index]}
                  alt="Preview"
                  className="w-32 h-32 object-cover rounded-lg"
                />
              </div>
            )} */}
          </div>
        ))}
        <div>
          <label className="block text-sm font-medium text-gray-700">
            Upload Video
          </label>
          <input
            type="file"
            name="video"
            className="mt-1 block w-full p-2 border border-gray-300 rounded-lg"
            accept="video/*"
            onChange={handleInputChange}
          />
          {videoPreview && (
            <video controls className="mt-3 w-64 h-32">
              <source src={videoPreview} type="video/mp4" />
            </video>
          )}
        </div>
        <button
          type="submit"
          className={`px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 ${
            isSubmitting ? "opacity-50 cursor-not-allowed" : ""
          }`}
          disabled={isSubmitting} // Disable the button when submitting
        >
          {isSubmitting ? (
            <span className="animate-spin">Loading....</span>
          ) : (
            "Add Product"
          )}
        </button>
      </form>
    </div>
  );
};

export default AddProduct;
